import React from 'react';
import './RichTextViewer.css';
const RichTextViewer = (props) => {
    return (
        <div className="container mt-5 mb-5">
            <div className="rich-text-viewer" dangerouslySetInnerHTML={{ __html: props.content.html }} />
        </div>
    );
};

export default RichTextViewer;
